import {pageInfo, detailInfo, downtemplate, uploadCustomerGroup, deleteData, exportData, submit, deleteBatchs, initPage } from './../api';
const soldToGroup = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    detailInfoObj: null,
    downtemplateObj: null,
    uploadCustomerGroupObj: null,
    deleteDataObj: null,
    exportDataObj: null,
    submitObj: null,
    deleteBatchObj: null,
    initPageObj: null
  },
  mutations: {
    PAGE_INFO(state,data){
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({ ...item, btns: [true, true] }));
    },
    DETAIL_INFO(state,data){
      state.detailInfoObj = data.obj || {};
    },
    DOWN_TEMPLATE_DATA(state,data){
      state.downtemplateObj = data;
    },
    UPLOAD_CUSTOMER_GROUP_DATA(state,data){
      state.uploadCustomerGroupObj = data;
    },
    DELETE_DATA(state,data){
      state.deleteDataObj = data;
    },
    EXPORT_DATA(state,data){
      state.exportDataObj = data;
    },
    SUBMIT_DATA(state,data){
      state.submitObj = data;
    },
    DELETE_BATCH_DATA(state,data){
      state.deleteBatchObj = data;
    },
    INIT_PAGE(state,data) {
      state.initPageObj = data.obj || {};
    }
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async detailInfo({commit}, obj){
      let resp = await detailInfo(obj);
      commit('DETAIL_INFO', resp);
    },
    async downtemplate({commit}, obj){
      let resp = await downtemplate(obj);
      commit('DOWN_TEMPLATE_DATA', resp);
    },
    async uploadCustomerGroup({commit}, obj){
      let resp = await uploadCustomerGroup(obj);
      commit('UPLOAD_CUSTOMER_GROUP_DATA', resp);
    },
    async exportData({commit}, obj){
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    async deleteData({commit}, obj){
      let resp = await deleteData(obj);
      commit('DELETE_DATA', resp);
    },
    async submit({commit}, obj){
      let resp = await submit(obj);
      commit('SUBMIT_DATA', resp);
    },
    async deleteBatch({commit}, obj){
      let resp = await deleteBatchs(obj);
      commit('DELETE_BATCH_DATA', resp);
    },
    //初始化页面事件
    async initPage({commit}, obj){
      let resp = await initPage(obj);
      commit('INIT_PAGE', resp);
    }
  }
}
export default soldToGroup



// WEBPACK FOOTER //
// ./src/page/md/soldToGroup/store/soldToGroup.store.js